export default {
  api: {
    url: process.env.VUE_APP_API_HOST,
    version: process.env.VUE_APP_API_VERSION,
    timeout: 200000,
  },
  localStorage: {
    keys: {
      session: "session",
    },
  },
};



// WEBPACK FOOTER //
// ./src/config/settings.js